export default "__VITE_ASSET__mMx7lpLD__"